// import React from 'react'

// function CatersPitchDetails() {
//   return (
//     <div>CatersPitchDetails</div>
//   )
// }

// export default CatersPitchDetails

import React, { useState, useEffect } from "react";
import {
  AuthService,
  EventService,
  EventApplicationService,
} from "../../../services";

import ReactPaginate from "react-paginate";
import { Button, Table } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { injectModels } from "../../../redux/injectModels";
import { ApplicationType } from "../../../constants/Enum";
import {
  formatAmount,
  handleConsoleError,
} from "../../../utils/common-methods";
import { toast } from "react-toastify";
//import _ from "lodash";

const CatersPitchDetails = (props) => {
  const { eventId } = useParams();
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();
  const [amountLabel, setAmountLabel] = useState("Pitch Amount");

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  useEffect(() => {
    getUnitData();
  }, []);

  const getEventCateringApplications = async (eventId) => {
    try {
      if (eventId) {
        const res = await EventApplicationService.getEventApplicationByEventId(
          eventId,
          "C"
        );
        if (res?.isSuccess && res?.data && res?.data.length > 0) {
          const appType = res?.data?.[0]?.applicationType;
          if (appType === ApplicationType.Tender) {
            setAmountLabel("Minimum Bid");
          }
          if (appType === ApplicationType.Turnover) {
            setAmountLabel("Commitment Fee");
          }
          if (appType === ApplicationType.Bid) {
            setAmountLabel("Minimum Starting Bid");
          }
        }
      }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const getUnitData = async () => {
    try {
      props.application.setLoading(true);
      if (eventId) {
        const res = await EventService.getUnitList(eventId);
        if (res?.isSuccess && res?.data?.length > 0) {
          await getEventCateringApplications(eventId);
          setFilteredData(res?.data);
        }
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleEdit = async (id) => {
    try {
      EventService.setPitchId(id);
      navigate(
        routes.CATERS_ACCOUNT_EDIT_PITCH.replace(":eventId", eventId).replace(
          ":unitId",
          id
        )
      );
    } catch (error) {}
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  const handleCreatePitch = async (e) => {
    EventService.removePitchId(); //change
    navigate(routes.CATERS_ACCOUNT_CREATE_PITCH.replace(":eventId", eventId));
  };

  return (
    <React.Fragment>
      {/* <section className="subscription-banner p-0">
        <div className="container">
          <h3> Pitches</h3>
        </div>
      </section> */}
      <section className="edit-form-table">
        <div className="container">
          <div className="verifier-buttton">
            <Button onClick={handleCreatePitch}>Create New Unit</Button>{" "}
          </div>
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Pitch Title</th>
                  {/* <th>
                    <div>Pitch Size (m)</div>
                    <div>Width x Length</div>
                  </th> */}
                  <th>{amountLabel} (£)</th>
                  <th>Total Available Unit</th>
                  <th>Maximum Individual Applications Allowed</th>
                  <th>Refundable</th>
                  <th>Visibility Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData && paginatedData.length > 0 ? (
                  <React.Fragment>
                    {paginatedData.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{calculateSNo(idx)}</td>
                          <td>{item?.unitTitle}</td>
                          {/* <td>
                            {item.unitLength} x {item.unitWidth}
                          </td> */}
                          <td>£{formatAmount(item?.amount)}</td>
                          <td>{item?.totalUnit}</td>
                          <td>{item?.maxAllowed}</td>
                          <td>
                            {item?.refundable === true ? (
                              <i className="ri-check-fill"></i>
                            ) : (
                              <i className="ri-close-circle-line"></i>
                            )}
                          </td>
                          <td>
                            {item?.isActive === true ? (
                              <i className="ri-check-fill"></i>
                            ) : (
                              <i className="ri-close-circle-line"></i>
                            )}
                          </td>
                          <td>
                            <div className="delete-create">
                              <Link
                                title="Edit"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEdit(item?.id);
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <i className="ri-pencil-line"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <tr>
                    <td colSpan="10 mt-2">No results found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="table-footer">
            <p className="mb-3">
              <strong>Total Count: {filteredData.length}</strong>
            </p>
            {filteredData.length === 0 ? "" : renderPagination()}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(CatersPitchDetails);
